import { fetchData } from 'modules/Axios';
import { showToast } from 'modules/Notifications';

export const defaultState = {
  campaignData: {},
  audiences: [],
  dataLoading: true,
};

export const RECEIVE_CAMPAIGN = 'RECEIVE_CAMPAIGN';

export const receiveCampaignDetails = payload => ({
  type: RECEIVE_CAMPAIGN,
  payload
});

export const RECEIVE_CAMPAIGN_AUDIENCES = 'RECEIVE_CAMPAIGN_AUDIENCES';

export const receiveCampaignAudiences = payload => ({
  type: RECEIVE_CAMPAIGN_AUDIENCES,
  payload
});

export const initCampaign = id => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const campaignsURL = `/brands/${brand.id}/campaigns/${id}`;
    const audiencesURL = `/brands/${brand.id}/campaigns/${id}/audiences`;
    try {
      const campaign = await dispatch(fetchData(campaignsURL));
      const audiences = await dispatch(fetchData(audiencesURL));
      dispatch(receiveCampaignDetails(campaign));
      dispatch(receiveCampaignAudiences(audiences));
    } catch (e) {
      console.error(e);
      dispatch(showToast({
        state: 'ERROR',
        title: 'Error',
        message: 'Issue retrieving campaign details. Please try again later',
        dismissible: true,
        dismissAfter: 1500,
      }));
    } finally {
      dispatch(dataLoading(false));
    }
  };
};

export const fetchCampaignOnboardingTasks = (campaignId, integrationId) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const URL = `/brands/${brand.id}/campaigns/${campaignId}/integrations/${integrationId}/onboarding-tasks`;
    try {
      const tasks = await dispatch(fetchData(URL));
      return tasks;
    } catch (e) {
      console.error(e);
      dispatch(showToast({
        state: 'ERROR',
        title: 'Error',
        message: 'Issue retrieving campaign onboarding tasks. Please try again later',
        dismissible: true,
        dismissAfter: 1500,
      }));
      return null;
    }
  };
};

export const CAMPAIGN_DATA_LOADING = 'CAMPAIGN_DATA_LOADING';

export const dataLoading = (payload) => ({
  type: CAMPAIGN_DATA_LOADING,
  payload,
});

export const RESET_CAMPAIGN_DETAILS_ROUTE_DATA = 'RESET_CAMPAIGN_DETAILS_ROUTE_DATA';
export const resetRouteData = () => ({
  type: RESET_CAMPAIGN_DETAILS_ROUTE_DATA,
});

export default function reducer(state = defaultState, action = {}) {
  switch (action.type) {
    case RECEIVE_CAMPAIGN:
      return {
        ...state,
        campaignData: action.payload,
      };
    case RECEIVE_CAMPAIGN_AUDIENCES:
      return {
        ...state,
        audiences: action.payload,
      };
    case CAMPAIGN_DATA_LOADING:
      return {
        ...state,
        dataLoading: action.payload,
      };
    case RESET_CAMPAIGN_DETAILS_ROUTE_DATA:
      return { ...defaultState };
    default:
      return state;
  }
}
